import { CreditCard, Plane, ShoppingCart, User } from "lucide-react";
import { formatPrice } from "@ckgo2/shared/utils";
import type { Customer } from "./types";

interface CustomerStatsCardsProps {
  customer: Customer;
}

export default function CustomerStatsCards({ customer }: CustomerStatsCardsProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-4">
      <div className="card">
        <div className="flex items-center gap-3">
          <div className="bg-primary-100 dark:bg-primary-900/30 flex h-10 w-10 items-center justify-center rounded-lg">
            <CreditCard className="text-primary-600 h-5 w-5" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Total spent</p>
            <p className="text-xl font-bold text-gray-900 dark:text-white">
              {formatPrice(customer.totalSpent || 0)}
            </p>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="flex items-center gap-3">
          <div className="bg-success-100 dark:bg-success-900/30 flex h-10 w-10 items-center justify-center rounded-lg">
            <Plane className="text-success-600 h-5 w-5" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Number of trips</p>
            <p className="text-xl font-bold text-gray-900 dark:text-white">
              {customer.tripsCount || 0}
            </p>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="flex items-center gap-3">
          <div className="bg-warning-100 dark:bg-warning-900/30 flex h-10 w-10 items-center justify-center rounded-lg">
            <ShoppingCart className="text-warning-600 h-5 w-5" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Orders</p>
            <p className="text-xl font-bold text-gray-900 dark:text-white">
              {customer.orders?.length || 0}
            </p>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-purple-100 dark:bg-purple-900/30">
            <User className="h-5 w-5 text-purple-600" />
          </div>
          <div>
            <p className="text-sm text-gray-500">Score</p>
            <p className="text-xl font-bold text-gray-900 dark:text-white">{customer.score || 0}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
